import axios from "../plugins/parseAxios";
export class AreaAccountingProductAPI {
  static getAreaAccountingProductByMarket(payload) {
    return axios.post("functions/getAreaAccountingProductByMarket", payload);
  }
  static createAreaAccountingProduct(formData) {
    return axios.post("functions/createAreaAccountingProduct", formData);
  }
  static updateAreaAccountingProduct(formData) {
    return axios.post("functions/updateAreaAccountingProduct", formData);
  }
  static createUpdateAreaAccountingProduct(formData) {
    return axios.post("functions/createUpdateAreaAccountingProduct", formData);
  }
  static getAreaAccountingProductByAreas(areaIds) {
    return axios.post("functions/getAreaAccountingProductByAreas", {
      areaIds
    });
  }
  static getAreaAccountingProduct(id) {
    return axios.post("functions/getAreaAccountingProduct", {
      id
    });
  }
  static getAreaAccountingProductPrice(formData) {
    return axios.post("functions/getAreaAccountingProductPrice", formData);
  }
}
